import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { IPosition, ISearchPositionInput, ISearchPositionResponse, ISearchPositionResult } from "../../../types/position";
import { useLazyQuery } from "@apollo/client";
import { GET_POSITION_DETAIL, SEARCH_POSITION} from "../../../graphql/position-gql";
import SearchPositionRoleForm, { SearchPositionFormRef } from "./search-position-role-form";
import SearchPositionRoleResult, { searchPositionRoleSelectedIndividual, searchPositionRoleSelectedTitle } from "./search-position-role-result";
import SpinnerOverlay from "../../common/spinner/spinner";
import { OrgReducerContext, errorSearch, messageAfterSearchResult } from "../../org/org-context";
import { notifySuccess, notifyWarning } from "../../../services/notification";
import { GET_ORG_DETAILS } from "../../../graphql/org-gql";
import { IOrgResponse } from "../../../types/org";
import { GET_INDIVIDUAL } from "../../../graphql/individual-gql";

export type SearchPositionRoleRef = {
  unselect: () => void;
};

const SearchPositionRole = forwardRef<SearchPositionRoleRef>((props, ref) => {
  const [searchResults, setSearchResults] = useState<ISearchPositionResult[] | undefined>();
  const [getPositionDetail,{loading:positionDetailLoading}]= useLazyQuery(GET_POSITION_DETAIL)
  const [getIndividual,{loading:individualLoading}] = useLazyQuery(GET_INDIVIDUAL)
  const [inputChanged,setInutChanged] = useState(true)
  const [searchPosition, { loading:searchPositionLoading, error:searchPositionError }] = useLazyQuery<ISearchPositionResponse>(SEARCH_POSITION,{fetchPolicy: 'no-cache'});
  const searchPositonFormRef = useRef<SearchPositionFormRef | null>(null);
  const [getOrgDetail,{loading:OrgDetailLoading}] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS)
  const [state, dispatch] = useContext(OrgReducerContext);
  const resetState = () => dispatchEvent
  const [isInputError, setIsInputError] = useState(false)

  const unselect=()=>{
    resetState();
  }

  useImperativeHandle(ref, () => ({
    unselect
  }));

  const updateSearchResults = (results: ISearchPositionResult[] | undefined) => {
    setInutChanged(false)
    if(results){
      if(results.length>700)
        results = results.slice(0,700);
      setSearchResults(results);
    }
  }

  const onTitleSelect = async (item: ISearchPositionResult) => {
    try {
        dispatch({type: 'set-last-selected-item', payload: searchPositionRoleSelectedTitle(item) });
        const positionDetailResponse = await getPositionDetail({ variables: { positionId: item.positionId } });
        if (positionDetailResponse.data?.position) {
          dispatch({
            type:'set-position-search-position',
            payload:positionDetailResponse.data.position
          })
          dispatch({
            type:'set-position-search-individual'
          })
          dispatch({
              type:'set-position-search-position-role'
          })
          dispatch({type:'set-position-search-message'})
        }
        if (item?.orgId) {
          getOrgDetail({ variables: { id: item.orgId } }).then((response) => {
            response?.data?.org && dispatch({
              type:'set-position-search-org',
              payload: response.data.org
            });
          })
        }else{
            dispatch({type:'set-position-search-org'});
        }
      } catch (error:any) {
        console.error('Error:', error.message);
      }
  }

  const onIndividualSelect = async (item: ISearchPositionResult) => {
    try 
    {
        dispatch({type: 'set-last-selected-item', payload: searchPositionRoleSelectedIndividual(item) });
        const positionDetailResponse = await getPositionDetail({ variables: { positionId: item.positionId } });
        const individuallResponse = await getIndividual({ variables: { individualId:item.individualId } });
        const orgDetailResponse = await getOrgDetail({ variables: { id: item.orgId } });
        if(individuallResponse?.data?.individual){
          const result = individuallResponse.data.individual;
          //console.log("result:",result)
          const individual = {...result,honorific:result.honorificTitle,honorificTitle:result.honorificTitle?.label}
          //console.log("individual:",individual)
          dispatch({
            type: 'set-position-search-individual',
            payload: individual
          })
        }
        if (positionDetailResponse.data?.position) {
          dispatch({
            type:'set-position-search-position-role',
            payload:positionDetailResponse.data.position
          })
        }
        if(orgDetailResponse.data?.org){
          dispatch({
            type:'set-position-search-org',
            payload: orgDetailResponse.data.org
          });
        }    
        dispatch({type:'set-position-search-position'})    
        dispatch({type:'set-position-search-message'})
        
      } catch (error:any) {
        console.error('Error:', error.message);
      }
  }

  const onChange = () => {
    setInutChanged(true)
  }

  const onSearch=(input:ISearchPositionInput,isValid: boolean)=>{
    //console.log("isValid",isValid)
    setSearchResults([]);
    dispatch({type:'reset'})

    if(!isValid){
      dispatch({type:'reset'})
      dispatch({type:'set-position-search-error',payload:errorSearch})
      dispatch({type:'set-position-search-message'})
      setIsInputError(true);

    }else
      searchPosition({ variables: { input },fetchPolicy: 'no-cache',
        onCompleted: (data) => {data && notifySuccess()}
      })
          .then((response:any )=> {
              response.data.searchPosition?.message && notifyWarning(response.data.searchPosition?.message)
              updateSearchResults(response.data?.searchPosition.positions)
              dispatch({type:'set-position-search-message',payload:messageAfterSearchResult})
              dispatch({type:'set-position-search-error'})
          });

  }

  return (
    <section id="search_pos_role">
      {positionDetailLoading || individualLoading || OrgDetailLoading || searchPositionLoading && <SpinnerOverlay/>}
      <SearchPositionRoleForm onSearch={onSearch} onChange={onChange} loading={searchPositionLoading} error={searchPositionError} ref={searchPositonFormRef}></SearchPositionRoleForm>
      <br/>
      <SearchPositionRoleResult data={searchResults} selected={state?.lastSelectedItem} onTitleSelect={onTitleSelect} onIndividualSelect={onIndividualSelect}  inputChanged={inputChanged} isInputError={isInputError}/>
    </section>
  )
});

export default SearchPositionRole;
